import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ButtonDirective } from "./button/button.directive";
import { TooltipModule } from "./tooltip/tooltip.module";
import { CurrencyFormatDirective } from "./currency-format/currency-format.directive";
import { DisplayForW2Directive } from './display-for-w2.directive';
import { HideForSaasDirective } from "./hide-for-saas.directive";


@NgModule({
    declarations: [
        ButtonDirective,
        CurrencyFormatDirective,
        DisplayForW2Directive,
        HideForSaasDirective
    ],
    imports: [
        CommonModule,
        TooltipModule
    ],
    exports: [
        ButtonDirective,
        TooltipModule,
        CurrencyFormatDirective, 
        DisplayForW2Directive,
        HideForSaasDirective
    ]
})
export class DirectivesModule { }
